export default [
  {
    path: '/authentication/api-page', 
    component: () => import('@/view/authentication/api-auth/api-page'),
    name: 'apipage'
    // meta: { pageName: 'river_diversion_detail' }
  },
  {
    path: '/authentication/api-base-360', 
    component: () => import('@/view/authentication/api-auth/base-360'),
    name: 'apiAuthBase360'
    // meta: { pageName: 'river_diversion_detail' }
  },
  // api授信
  {
    path: '/authentication/api-auth', 
    component: () => import('@/view/authentication/api-auth/index'),
    name: 'apiAuth'
    // meta: { pageName: 'river_diversion_detail' }
  },
  // api授信基础信息补充
  {
    path: '/authentication/api-base', 
    component: () => import('@/view/authentication/api-auth/base'),
    name: 'apiAuthBase'
    // meta: { pageName: 'river_diversion_detail' }
  },
  // api授信结果页
  {
    path: '/authentication/api-result', 
    component: () => import('@/view/authentication/api-auth/result'),
    name: 'apiAuthResult'
    // meta: { pageName: 'river_diversion_detail' }
  }
]